import React, { JSX } from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { getVisaLabelFromValue } from 'data';

function VisaPrepAdditionalHistoryStep2Info(props: IVisaPrepForm): JSX.Element {
  const renderOtherUKVisas = (): React.ReactNode[] => {
    const allOtherUKVisas: React.ReactNode[] = [];
    if (props.otherUkVisas && props.otherUkVisas.length) {
      for (const [i, ukVisa] of props.otherUkVisas.entries()) {
        allOtherUKVisas.push(
          <React.Fragment key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_TYPE}-${i}`}
              value={getVisaLabelFromValue(ukVisa.visaType)}
              label={`Other territory visa ${i + 1}: Type of Visa`}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_DATE_OF_ISSUE}-${i}`}
              label={`Other territory visa ${i + 1}: Date of Issue`}
              value={ukVisa.issueDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_DATE_OF_EXPIRY}-${i}`}
              label={`Other territory visa ${i + 1}: Date of Expiry`}
              value={ukVisa.expiryDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_COUNTRY}-${i}`}
              label={`Other territory visa ${i + 1}: Country / Territory`}
              value={ukVisa.country}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.OTHER_UK_VISA_ISSUING_AUTH}-${i}`}
              value={ukVisa.issuingAuthority}
              label={`Other territory visa ${i + 1}: Issuing Authority`}
            />
          </React.Fragment>,
        );
      }
    }
    return allOtherUKVisas;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_OTHER_UK_VISAS}
        label={'Has other UK visas'}
        fullLabel={
          'Have you been issued any visas for UK Overseas Territories or Commonwealth Countries in the last 10 years? (Note: not including the UK itself):'
        }
        value={boolToYesNo(props.hasOtherUkVisas)}
      />
      {props.hasOtherUkVisas ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            label="How many visas have you been issued?"
            value={props.otherUkVisas?.length}
          />

          <SummaryGroup title="Other UK visas" key={'other-uk-visas'}>
            {renderOtherUKVisas()}
          </SummaryGroup>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep2Info;
